export const styles = {
    margin: { margin: '1%' },
    paragraph: { fontSize: '20px', lineHeight: 'initial', textAlign: 'justify' },
    image: { textAlign: 'center' }
};